import React from "react";
import { toast, type Id, type ToastOptions } from "react-toastify";
import { Toast, type ToastPropsType } from "./";

export interface OpenToastParamsType extends ToastPropsType {
  options?: ToastOptions;
}

export const useToast = () => {
  const openToast = ({
    message,
    messageHeader,
    options,
    ...toastProps
  }: OpenToastParamsType): Id => {
    return toast(
      ({ closeToast }) => (
        <Toast
          message={message}
          messageHeader={messageHeader}
          closeToast={closeToast}
          {...toastProps}
        />
      ),
      {
        containerId: "page-container",
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeButton: false,
        ...options,
      }
    );
  };

  const closeToast = (id?: Id): void => {
    toast.dismiss(id);
  };

  return { openToast, closeToast };
};

export default useToast;
